import React, { useEffect, useState } from 'react'
import { HashRouter, Routes, Route } from 'react-router-dom'
import liff from '@line/liff'

import { routerConfig } from './router'
import FrontendAuth from './components/frontEndAuth'
import T from './utils/language'
import { checkImeiJp, checkLineApp } from './utils/env'
import { getLiffConfig } from './config'

function App() {
  useEffect(() => {
    document.title = T('ChargeSPOT 出厂绑定系统')
  }, [])

  useEffect(() => {
    checkImeiJp()
    checkLineApp()
  }, [])

  const liffConfig = getLiffConfig()
  const [liffInited, setLiffInited] = useState(liff.isInClient() ? false : null)
  useEffect(() => {
    if (liff.isInClient()) {
      liff.init(liffConfig).then(() => {
        setLiffInited(true)
      })
    }
  }, [liffConfig])

  if (liffInited === false) return null

  return (
    <HashRouter>
      <div className="App">
        <Routes>
          {/* 404 page */}
          <Route path="*" element={<FrontendAuth />} />

          {routerConfig.map((config) => (
            <Route
              key={config.path}
              path={config.path}
              element={
                <FrontendAuth config={config}>
                  <config.component />
                </FrontendAuth>
              }
            />
          ))}
        </Routes>
      </div>
    </HashRouter>
  )
}

export default App
